import GetProjectIterationLookupRequestModelBase from '../_generated/modelBases/get-project-iteration-lookup-request-model-base';

export default class GetProjectIterationLookupRequestModel extends GetProjectIterationLookupRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
